import { useEffect, useRef, useState } from "react";

export default function CountUp({ value, startDelay = 0, duration = 1900 }) {
  const match = String(value).match(/^([\d,]+)(.*)$/);
  const target = parseFloat((match?.[1] || "0").replace(",", "."));
  const suffix = match?.[2] || "";
  const decimals = (match?.[1] || "").includes(",") ? 1 : 0;
  const ref = useRef(null);
  const [started, setStarted] = useState(false);
  const [display, setDisplay] = useState((0).toFixed(decimals).replace(".", ","));

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStarted(true);
          io.disconnect();
        }
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!started) return;
    let raf;
    const t0 = performance.now() + startDelay * 1000;
    const tick = (now) => {
      const p = Math.min(1, Math.max(0, (now - t0) / duration));
      if (p >= 1) {
        setDisplay(target.toFixed(decimals).replace(".", ","));
        return;
      }
      const eased = 1 - Math.pow(2, -10 * p);
      setDisplay((target * eased).toFixed(decimals).replace(".", ","));
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [started, target, decimals, startDelay, duration]);

  return (
    <span ref={ref}>
      {display}
      {suffix}
    </span>
  );
}
